export default __webpack_public_path__ + "static/media/contact-crm.d7d8475e.svg";